(function () {
  'use strict';

  function pad(n) {
    return String(Math.max(0, n)).padStart(2, '0');
  }

  function render(el, diff) {
    var days = Math.floor(diff / 86400000);
    var hours = Math.floor((diff % 86400000) / 3600000);
    var minutes = Math.floor((diff % 3600000) / 60000);
    var seconds = Math.floor((diff % 60000) / 1000);

    var daysEl = el.querySelector('[data-countdown-days]');
    var hoursEl = el.querySelector('[data-countdown-hours]');
    var minutesEl = el.querySelector('[data-countdown-minutes]');
    var secondsEl = el.querySelector('[data-countdown-seconds]');

    if (daysEl) daysEl.textContent = pad(days);
    if (hoursEl) hoursEl.textContent = pad(hours);
    if (minutesEl) minutesEl.textContent = pad(minutes);
    if (secondsEl) secondsEl.textContent = pad(seconds);
  }

  function initCountdown(el) {
    var target = new Date(el.dataset.countdownTarget).getTime();
    if (isNaN(target)) return;

    var intervalId = setInterval(function () {
      var diff = target - Date.now();

      if (diff <= 0) {
        clearInterval(intervalId);
        el.remove();
        return;
      }

      render(el, diff);
    }, 1000);

    render(el, target - Date.now());
  }

  function init() {
    document.querySelectorAll('[data-countdown-target]').forEach(initCountdown);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
